// Garment context for /measurements. Router state is lost on the 3DLOOK redirect,
// so the last chosen garment is kept briefly in localStorage.
export const MEASURE_CTX_KEY = 'lunora_measure_ctx_v1';
export const MEASURE_CTX_TTL_MS = 6 * 60 * 60 * 1000;

export const resolveOrderContext = (state, storage = window.localStorage, now = Date.now()) => {
  if (state?.category) {
    try { storage.setItem(MEASURE_CTX_KEY, JSON.stringify({ ...state, ts: now })); } catch { /* ignore */ }
    return state;
  }
  try {
    const saved = JSON.parse(storage.getItem(MEASURE_CTX_KEY) || 'null');
    if (saved?.category && now - (saved.ts || 0) < MEASURE_CTX_TTL_MS) {
      const { ts, ...ctx } = saved;
      return ctx;
    }
  } catch { /* ignore */ }
  return state || {};
};
